// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"dd9fb8db","232":"79bf56a0","237":"cc701c95","357":"f8ace00d","526":"7c95adac","872":"991bfe1c"}[chunkId] + ".chunk.js";
};